"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomIconTypeEnum = void 0;
var CustomIconTypeEnum;
(function (CustomIconTypeEnum) {
    CustomIconTypeEnum["MONARCH_BIBLE"] = "MONARCH_BIBLE";
    CustomIconTypeEnum["MONARCH_GEOGRAPHY"] = "MONARCH_GEOGRAPHY";
    CustomIconTypeEnum["MONARCH_LANGUAGE"] = "MONARCH_LANGUAGE";
    CustomIconTypeEnum["MONARCH_MATH"] = "MONARCH_MATH";
    CustomIconTypeEnum["MONARCH_SCIENCE"] = "MONARCH_SCIENCE";
    CustomIconTypeEnum["CALVERT_ELECTIVE"] = "CALVERT_ELECTIVE";
    CustomIconTypeEnum["CALVERT_GEOGRAPHY"] = "CALVERT_GEOGRAPHY";
    CustomIconTypeEnum["CALVERT_LANGUAGE"] = "CALVERT_LANGUAGE";
    CustomIconTypeEnum["CALVERT_MATH"] = "CALVERT_MATH";
    CustomIconTypeEnum["CALVERT_SCIENCE"] = "CALVERT_SCIENCE";
    CustomIconTypeEnum["PROJECT_ICON"] = "PROJECT_ICON";
    CustomIconTypeEnum["OVERDUE_ICON"] = "OVERDUE_ICON";
    CustomIconTypeEnum["STARTED_ASSIGNMENT_ICON"] = "STARTED_ASSIGNMENT_ICON";
    CustomIconTypeEnum["LOCK_ICON"] = "LOCK_ICON";
    CustomIconTypeEnum["CUSTOM"] = "CUSTOM";
})(CustomIconTypeEnum || (exports.CustomIconTypeEnum = CustomIconTypeEnum = {}));
